<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>
    <a [routerLink]="['/company']">Company</a>
  </li>
  <li>
    <a [routerLink]="['/company/edit/{companyID}']">{{companyName}}</a>
  </li>
  <li>
    Financial Data List
  </li>
</ul>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Financial Data List </strong>
      <button type="button" class="btn btn-sm btn-primary pull-right" (click)="addNewFinancialData()" [appHasPermission]="{'Url': '/company/financeDetails/edit?goveva=true&email=', 'method':'put', 'menu': 'CompanyFinancialDetails'}">
        <i class="fa fa-plus"></i>Add</button>
    </span>
  </div>
  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-12">
        <div class="margin-bottom-50">
          <div class="table-responsive">
            <table id="financeDataTable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-hover compact cell-border nowrap stripe"
              style="cursor: pointer;" style="width:100%">
              <!-- style="width:3500px" -->
              <thead>
                <tr>
                  <!-- <th style="width:56px">Sr No.</th> -->
                  <th style="width:222px">Year </th>
                  <th style="width:150px">Date Of Last Update</th>
                  <th style="width:225px">Time of Last Update</th>
                  <th style="width: 10px; text-align: left;">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let finance of financialList; let count=index" style="line-height: 25px;">
               
                  <td tabindex="1">{{finance.FinancialYear }}</td>
                  <td tabindex="1">{{finance.ModifiedDate | date : "dd-MM-y"}}</td>
                  <td tabindex="1">{{finance.ModifiedDate | date : "h:mm a"}}</td>

                  <td style='white-space: nowrap'>

                    <button type="button" class="btn-sm btn btn-warning" (click)="loadFinanceDetailsById(finance._id,finance.FinancialYear)">
                      <span class="fa fa-pencil"></span>
                    </button>&nbsp;&nbsp;&nbsp;
                   
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>